var React = require('react');

function BackendDropdownMenuPostalRoutes (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M13.5 6l2-2-2-2h-4.5v-1.25c0-0.412-0.338-0.75-0.75-0.75h-0.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-5v4h5v1h-5.5l-1.5 1.5 1.5 1.5h5.5v6h2v-6h4v-3h-4v-1h4.5z"}));
}

BackendDropdownMenuPostalRoutes.displayName = "BackendDropdownMenuPostalRoutes";

BackendDropdownMenuPostalRoutes.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = BackendDropdownMenuPostalRoutes;

BackendDropdownMenuPostalRoutes.default = BackendDropdownMenuPostalRoutes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-postal-routes.svg
// module id = 994
// module chunks = 0